/* esm.sh - @radix-ui/react-tooltip@1.2.8 */
export * from "/*@radix-ui/react-tooltip@1.2.8/esnext/react-tooltip.mjs";
